export enum BILLING_PAYMENT_METHOD_TYPE {
  CARD = 'card',
  SEPA_DEBIT = 'sepa_debit',
}
